module.exports = __webpack_public_path__ + "static/media/flecha-down.a5c0a552.svg";